module.exports = __webpack_public_path__ + "img/device.276d8c24.jpg";